export default __webpack_public_path__ + "static/media/swiss-flower-dish.ac5e67f1.jpg";